// utils/asyncStorage.js

// For React Native use:
// import AsyncStorage from '@react-native-async-storage/async-storage';

// For web/React use localStorage as Async Storage
const AsyncStorage = {
  // Set item
  setItem: async (key, value) => {
    try {
      const stringValue = JSON.stringify(value);
      localStorage.setItem(key, stringValue);
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  },

  // Get item
  getItem: async (key) => {
    try {
      const value = localStorage.getItem(key);
      if (value !== null) {
        return Promise.resolve(JSON.parse(value));
      }
      return Promise.resolve(null);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  // Remove item
  removeItem: async (key) => {
    try {
      localStorage.removeItem(key);
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  },

  // Clear all items
  clear: async () => {
    try {
      localStorage.clear();
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  },

  // Get multiple items
  multiGet: async (keys) => {
    try {
      const values = keys.map((key) => {
        const value = localStorage.getItem(key);
        return [key, value ? JSON.parse(value) : null];
      });
      return Promise.resolve(values);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  // Set multiple items
  multiSet: async (keyValuePairs) => {
    try {
      keyValuePairs.forEach(([key, value]) => {
        localStorage.setItem(key, JSON.stringify(value));
      });
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  },

  // Remove multiple items
  multiRemove: async (keys) => {
    try {
      keys.forEach((key) => localStorage.removeItem(key));
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  },

  // Get all keys
  getAllKeys: async () => {
    try {
      const keys = [];
      for (let i = 0; i < localStorage.length; i++) {
        keys.push(localStorage.key(i));
      }
      return Promise.resolve(keys);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  // Merge item (for React Native compatibility)
  mergeItem: async (key, value) => {
    try {
      const existingValue = await AsyncStorage.getItem(key);
      const mergedValue = existingValue
        ? { ...existingValue, ...value }
        : value;
      return AsyncStorage.setItem(key, mergedValue);
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

export default AsyncStorage;
